<template>
  <div>
    <NBar title="年卡订单" :top="true"/>
    <div style="width: 100%;">
      <div class="top-div" :style="{zIndex:zIndex}">
        <div class="left" @click="switchMenu">
          <span ref="searchType">{{ searchList[query.searchType].text }}</span>
          <img :src="require('../../../resource/img/device/svg/arrow-down.svg')" style="width: 25px;height: 25px;">
        </div>
        <nut-searchbar ref="search" v-model="query.searchName" :place-text="'请输入'+searchList[query.searchType].text"
                       @submit="search" searchBtnIconColor="#194fff" style="margin: 0 10px 0 5px;flex: 1;"/>
      </div>
      <nut-menu :isVisible="isSearch" :list="searchList" type="simple" @close="switchMenu" @choose="chooseMenu">
        <div slot="custom" class="menu-simple">
          <ul>
            <li v-for="(item, index) in searchList" :key="index" :class="item.selected ? 'selected' : ''"
                :style="{color: item.selected ? '#1a87ff' : '#2d2d2d'}"
                @click="chooseMenu(item, index)">
              {{ item.text }}
              <span v-if="item.selected"><nut-icon type="tick" color="#1a87ff"></nut-icon></span>
            </li>
          </ul>
        </div>
      </nut-menu>
      <div style="display: flex;align-items: center;justify-content: space-between;height: 35px;">
        <span style="margin: 0 10px; color: #9B9B9B;">展示近3天的数据,输入单号可查询近一个月数据</span>
        <div @click="showFilter = true" style="margin-right: 10px;display: flex;align-items: center;">
          <span style="font-size: 14px;margin-right: 5px;">筛选</span>
          <img :src="require('../../../resource/img/device/svg/filter.svg')"
               style="width: 20px;height: 20px;">
        </div>
      </div>
      <!--筛选弹出窗口-->
      <nut-popup v-model="showFilter" position="top" closeable>
        <div style="margin-left: 10px;height: 45px;line-height: 45px;font-size: 14px;">筛选</div>
        <div style="margin-left: 10px; margin-top: 10px; height: 45px;line-height: 45px;font-size: 14px;">交易状态</div>
        <nut-row :gutter="8" style="background-color: white;padding: 10px 0;margin-bottom: 10px;">
          <nut-col :span="8">
            <div @click="goStatus(0)" class="flex-content"
                 :style="{color:orderStatus === 0 ? '#194fff' : '#848484',
                          borderColor:orderStatus === 0 ? '#194fff' : '#F2F2F2',
                          backgroundColor: orderStatus === 0 ? '#ffffff' : '#F2F2F2'}">
              全部
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(1)" class="flex-content"
                 :style="{color:orderStatus === 1 ? '#194fff' : '#848484',
                          borderColor:orderStatus === 1 ? '#194fff' : '#F2F2F2',
                          backgroundColor: orderStatus === 1 ? '#ffffff' : '#F2F2F2'}">
              交易成功
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(2)" class="flex-content"
                 :style="{color:orderStatus === 2 ? '#194fff' : '#848484',
                          borderColor:orderStatus === 2 ? '#194fff' : '#F2F2F2',
                          backgroundColor: orderStatus === 2 ? '#ffffff' : '#F2F2F2'}">
              未支付
            </div>
          </nut-col>
        </nut-row>
        <nut-buttongroup style="margin-top: 10px;">
          <nut-button type="light" @click="resetFilter">重置</nut-button>
          <nut-button @click="filterOk" style="background: #194fff;">确定</nut-button>
        </nut-buttongroup>
      </nut-popup>
      <!--筛选弹出窗口 end-->
      <div style="width: 100%;margin-top: 5px;">
        <m-list style="height:calc(100vh - 130px);" ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit"
                @loadlist="getData">
          <div slot="list">
            <div class="item" v-for="(item, index) in list" :key="index">
              <nut-cell v-if="item.payType === 'weixin'"
                        style="border-top-left-radius: 5px;border-top-right-radius: 5px;">
                <span slot="title">{{ getPayType(item) }}</span>
                <span slot="sub-title">{{ item.payTime }}</span>
                <span slot="avatar">
                  <img :src="require('../../../resource/img/device/svg/weixin_fang.svg')"
                       style="width: 50px;height: 50px;">
                </span>
                <span slot="desc" style="font-size: 16px;font-weight: bold;">
                <nut-price :price="item.payMoney" :need-symbol="false" :thousands="true" style="font-size: 16px;"/>
                  <span>元</span>
                </span>
              </nut-cell>
              <div class="sub">
                <span style="margin-left: 10px;">年卡金额</span>
                <div style="margin-right: 10px;">
                  <nut-price :price="item.totalMoney" :need-symbol="false" :thousands="true"/>
                  <span>元</span>
                </div>
              </div>
              <div class="sub">
                <span style="margin-left: 10px;">实际支付</span>
                <div style="margin-right: 10px;">
                  <nut-price :price="item.payMoney" :need-symbol="false" :thousands="true"/>
                  <span>元</span>
                </div>
              </div>
              <div class="sub">
                <span style="margin-left: 10px;">交易单号</span>
                <div style="margin-right: 10px;color: #f15532;">{{ item.thirdOrderId || '无' }}</div>
              </div>
              <div class="sub">
                <span style="margin-left: 10px;">订单号</span>
                <div style="margin-right: 10px;">{{ item.orderId }}</div>
              </div>
              <div class="sub">
                <span style="margin-left: 10px;">交易状态</span>
                <div style="margin-right: 10px;">{{ getOrderStatus(item) }}</div>
              </div>
              <div class="sub">
                <span style="margin-left: 10px;">商家名称</span>
                <div style="margin-right: 10px;">{{ item.merName }}</div>
              </div>
              <nut-cell :to="'/device/MemberDetail?uid='+ item.uid" :show-icon="true"
                        style="border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;padding: 10px;">
                <span slot="title">{{ item.userName }}</span>
                <span
                  slot="sub-title">{{ item.uid ? 'uid:' + item.uid : '' }} {{ item.sex === 1 ? '男' : item.sex === 2 ? '女' : '' }} 手机:{{ item.phone || '未知' }}</span>
                <span slot="avatar">
                  <nut-avatar :bg-icon="item.avatar ? '' : undefined" :bg-image="item.avatar || ''"></nut-avatar>
                </span>
              </nut-cell>
            </div>
          </div>
        </m-list>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 年卡订单
 */
export default {
  name: 'YearCardOrderList',
  props: ['orderId'],
  data () {
    return {
      zIndex: 0,
      isSearch: false,
      query: {
        searchName: '',
        searchType: 1,
        addressId: 0,
        paid: -1,
      },
      page: 1,
      limit: 20,
      searchList: [
        {
          id: 0,
          text: '用户ID',
          selected: false
        }, {
          id: 1,
          text: '订单号',
          selected: true
        }
      ],
      //是否显示筛选弹出窗口
      showFilter: false,
      orderStatus: 0,
      list: []
    }
  },
  created () {
    Object.assign(this.$data, this.$options.data())
    if (this.orderId != null) {
      this.query.searchName = this.orderId
      this.query.searchType = 1
    }
    this.getData()
  },
  methods: {
    search (value) {
      this.query.searchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.search.blur()
      this.getData()
    },
    getData () {
      let data = {
        searchType: this.query.searchType,
        searchName: this.query.searchName,
        page: this.page,
        limit: this.limit
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      if (this.query.paid !== -1) {
        data.paid = this.query.paid
      }
      this.$api.post({
        url: '/device/api/device/device-card-order/list',
        data: data
      }).then(res => {
        this.$refs.list.setRes(res)
      })
    },
    getPayType (item) {
      switch (item.payType) {
        case 'weixin':
          return '微信付款'
        case 'offline':
          return '线下付款'
      }
      return ''
    },
    switchMenu () {
      this.zIndex = 0
      if (!this.isSearch) {
        this.zIndex = 9999
      }
      this.isSearch = !this.isSearch
    },
    chooseMenu (item, index) {
      this.switchMenu()
      this.searchList.map((value, key) => value.selected = false)
      this.$set(this.searchList[index], 'selected', true)
      this.query.searchType = index
      this.$refs.searchType.innerText = item.text
    },
    goStatus (num) {
      this.orderStatus = num
      if (num === 0) {//全部
        this.query.paid = -1
      }
      if (num === 1) {//已支付
        this.query.paid = 1
      }
      if (num === 2) {//未支付
        this.query.paid = 0
      }
      this.getData()
    },
    //重置
    resetFilter () {
      this.query.addressId = 0
      this.orderStatus = 0
      this.query.paid = -1
    },
    //确认筛选
    filterOk () {
      this.getData()
      this.showFilter = false
    },
    //订单状态
    getOrderStatus (item) {
      let {paid} = item
      if (paid === 1) {
        return '已支付'
      } else if (paid === 0) {
        return '未支付'
      }
      return ''
    }
  }
}
</script>

<style scoped>
>>> .nut-menu .nut-menu-panel .menu-simple ul li.selected {
  color: #1a87ff;
}

.top-div {
  position: relative;
  background-color: white;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-div .left {
  position: relative;
  margin-left: 10px;
  font-size: 14px;
  height: 50px;
  min-width: 70px;
  display: flex;
  align-items: center;
}

.flex-content {
  font-size: 14px;
  user-select: none;
  color: #848484;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 7px 0;
  border: 1px solid #F2F2F2;
}

.item {
  margin: 0 10px 10px 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: white;
}

.item .sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #848484;
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/YearCardOrderList.vue